import ActionType from 'actions/ActionType'

export default (
  state = {
    From: null,
    To: null,
    sms: true,
    email: true,
    call: true,
    formsub: true,
    search: '',
  },
  action,
) => {
  switch (action.type) {
    case ActionType.Inbox.HANDLE_SEARCH_OPTIONS_CHANGE:
      return {
        ...state,
        [action.property]: action.payload,
      }
    case ActionType.Inbox.SELECT_CONVERSATION:
      return {
        From: null,
        To: null,
        sms: true,
        email: true,
        call: true,
        formsub: true,
        search: '',
      }
    case ActionType.Inbox.CLEAR_FILTERS:
      return {
        From: null,
        To: null,
        sms: true,
        email: true,
        call: true,
        formsub: true,
        search: '',
      }
    default:
      return state
  }
}
